<h3 class="mb-4">Liên kết tài khoản</h3>
<div class="alert alert-primary">
  <div class="d-flex flex-start w-100">
    <div class="mr-2 hidden-md-down">
      <span class="icon-stack icon-stack-lg">
        <i class="base base-6 icon-stack-3x opacity-100 color-primary-500"></i>
        <i
          class="base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical"
        ></i>
        <i class="fal fa-info icon-stack-1x opacity-100 color-white"></i>
      </span>
    </div>
    <div class="d-flex flex-fill">
      <div class="flex-fill">
        <p class="mb-0">
          Tính năng này cho phép người dùng đăng nhập vào ứng dụng bằng cách sử
          dụng tài khoản Google hoặc Facebook.
        </p>
      </div>
    </div>
  </div>
</div>
<div class="loading-frame-wrap">
  @if (isLoading) {
  <div class="loading-overlay"></div>
  }
  <ul class="user__profile-info">
    @for (item of linkedMethod; track item.displayAccountText) { @if(item.method
    == 'gmail') {
    <li>
      <div class="row" [class.disabled]="!item.isEnable">
        <div class="col-6 col-lg-4 col-xl-4">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="24"
              height="24"
              viewBox="0 0 48 48"
              class="mr-2"
            >
              <path
                fill="#FFC107"
                d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
              ></path>
              <path
                fill="#FF3D00"
                d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
              ></path>
              <path
                fill="#4CAF50"
                d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
              ></path>
              <path
                fill="#1976D2"
                d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
              ></path>
            </svg>
            {{ item.displayMethodText }}
          </span>
        </div>
        @if(item.isEnable) {
          <div class="col">
            <div *ngIf="item.status === 'active'; else notLinked">
              {{ item.displayAccountText }}
              <a
                class="text-danger cursor-pointer"
                (click)="this.unLinkgoogleAccount()"
              >
                <u><i> Hủy liên kết </i></u>
              </a>
            </div>
            <ng-template #notLinked>
              <a class="cursor-pointer" (click)="onLinkGoogleAccount()">
                <u><i> Liên kết ngay </i></u>
              </a>
            </ng-template>
          </div>
        } @else {
          <div class="col">
            Coming soon...
           </div>
        }

      </div>
    </li>
    } @if(item.method == 'microsoft') {
    <li>
      <div class="row disabled">
        <div class="col-6 col-lg-4 col-xl-4">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="24"
              height="24"
              viewBox="0 0 48 48"
              class="mr-2"
            >
              <path
                fill="#ff5722"
                d="M6 6H22V22H6z"
                transform="rotate(-180 14 14)"
              ></path>
              <path
                fill="#4caf50"
                d="M26 6H42V22H26z"
                transform="rotate(-180 34 14)"
              ></path>
              <path
                fill="#ffc107"
                d="M26 26H42V42H26z"
                transform="rotate(-180 34 34)"
              ></path>
              <path
                fill="#03a9f4"
                d="M6 26H22V42H6z"
                transform="rotate(-180 14 34)"
              ></path>
            </svg>
            {{ item.displayMethodText }}
          </span>
        </div>
        <div class="col ">
          Coming soon...
        </div>
      </div>
    </li>
    } @if(item.method == 'facebook') {
    <li>
      <div class="row disabled">
        <div class="col-6 col-lg-4 col-xl-4">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1024 1024"
              width="24"
              height="22"
              id="facebook"
              class=" mr-2"
            >
              <path
                fill="#1877f2"
                d="M1024,512C1024,229.23016,794.76978,0,512,0S0,229.23016,0,512c0,255.554,187.231,467.37012,432,505.77777V660H302V512H432V399.2C432,270.87982,508.43854,200,625.38922,200,681.40765,200,740,210,740,210V336H675.43713C611.83508,336,592,375.46667,592,415.95728V512H734L711.3,660H592v357.77777C836.769,979.37012,1024,767.554,1024,512Z"
              ></path>
              <path
                fill="#fff"
                d="M711.3,660,734,512H592V415.95728C592,375.46667,611.83508,336,675.43713,336H740V210s-58.59235-10-114.61078-10C508.43854,200,432,270.87982,432,399.2V512H302V660H432v357.77777a517.39619,517.39619,0,0,0,160,0V660Z"
              ></path>
            </svg>
            {{ item.displayMethodText }}
          </span>
        </div>
        <div class="col">
         Coming soon...
        </div>
      </div>
    </li>
    } }
  </ul>
</div>
